// components/Tabs.jsx

import {
	fetchCyberSecurity,
	fetchFortigateGraph,
	fetchPeplinkGraph,
	fetchStarlinkAlerts,
	fetchStarlinkTelemetryUsage,
	fetchYahclickData,
	fetchYahclickGraph,
	fetchYahclickGraphNG,
} from "@services/vesselService";
import {
	LoadingYahclick,
	loadingCybersecurity,
	setClearFortigate,
	setClearPeplink,
	setClearStarlinkTab,
	setClearYahclick,
	setCybersecurityData,
	setInmarsatData,
	setLoadingFortigate,
	setLoadingPeplink,
	setLoadingVesselDetailsStarlink,
	setVouchersData,
	setVoucherTokensData,
	setYahclickData,
} from "@store/modules/vesselsSlice";
import { getCurrentMonthRange } from "@utils/helpers";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Tabs = ({ defaultTab, tabs }) => {
	const [selectedTab, setSelectedTab] = useState(defaultTab);
	const token = useSelector((state) => state.auth.user.token);
	const intelsats = useSelector((state) => state.modules.vessels.vesselDetails?.intelsats);
	const vesselId = useSelector((state) => state.modules.vessels.selectedVessel?.id);

	const starlinks = useSelector((state) => state.modules.vessels.vesselDetails?.starlinks);

	const hasSmartboxes = useSelector(
		(state) => state.modules.vessels.vesselDetails?.smartboxes?.length,
	);

	const hasStarlinks = useSelector(
		(state) => state.modules.vessels.vesselDetails?.starlinks?.length,
	);

	const hasCyberSecurity = useSelector(
		(state) => state.modules.vessels.vesselDetails?.cybersecurity_id?.length,
	);

	const hasPeplink = useSelector((state) => state.modules.vessels.peplink?.hasPeplink);

	const hasFortigate = useSelector((state) =>
		state.modules.vessels.vesselDetails?.modules?.some((mod) => mod.name === "Fortigate"),
	);

	const yahclickDetails =
		useSelector((state) => state.modules.vessels?.vesselDetails?.yahclicks) || [];

	const yahclickIds = yahclickDetails.filter((item) => item.type == "0").map((item) => item.id);

	const yahclickIdsNG = yahclickDetails.filter((item) => item.type == "1").map((item) => item.id);

	const hasVouchers = useSelector((state) =>
		state.modules.vessels.vesselDetails?.modules?.some((mod) => mod.name === "voucher Services"),
	);

	const hasYahsatServices = useSelector((state) =>
		state.modules.vessels.vesselDetails?.modules?.some((mod) => mod.name === "Yahsat Services"),
	);

	const hasVoucherToken = useSelector(
		(state) => state.modules.vessels?.vesselDetails?.captive_portals?.length > 0 || false,
	);
	const hasInmarsat = true;

	const page = useSelector((state) => state.modules.vessels.vouchers.pagination.page);
	const perPage = useSelector((state) => state.modules.vessels.vouchers.pagination.perPage);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const now = new Date();

	const previousMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
	const prevYear = previousMonthDate.getFullYear();

	const handleTabClick = async (tabName, isDisabled) => {
		if (isDisabled) return;

		setSelectedTab(tabName);

		if (tabName === "starlink") {
			await dispatch(setClearStarlinkTab());
			dispatch(setLoadingVesselDetailsStarlink(true));
			if (vesselId) {
				await fetchStarlinkAlerts(token, vesselId, dispatch, navigate);
			}
			if (starlinks && starlinks.length > 0) {
				await Promise.all(
					starlinks.map(async (starlink) => {
						const usage_this_month =
							starlink?.subscriptions &&
							starlink?.subscriptions.find(
								(sub) =>
									sub.month === new Date().getMonth() + 1 && sub.year === new Date().getFullYear(),
							)?.usage;

						const usage_previous_month =
							starlink?.subscriptions &&
							starlink?.subscriptions.find(
								(sub) => sub.month === new Date().getMonth() - 1 && sub.year === prevYear,
							)?.usage;

						await fetchStarlinkTelemetryUsage(
							token,
							starlink.id,
							starlink?.kit_number,
							usage_this_month,
							usage_previous_month,
							starlink?.device_id,
							starlink?.service_line_number,
							dispatch,
							navigate,
						);
					}),
				);
			} else {
				dispatch(setLoadingVesselDetailsStarlink(false));
			}
		} else if (tabName === "cellular") {
			await dispatch(setClearPeplink());
			await dispatch(setLoadingPeplink(true));
			if (hasPeplink) {
				const currentMonth = getCurrentMonthRange();
				await Promise.all([
					fetchPeplinkGraph(
						token,
						vesselId,
						null,
						currentMonth.start.toISOString(),
						currentMonth.end.toISOString(),
						"Cellular",
						"Bandwidth Cellular Usage",
						dispatch,
						navigate,
					),
					fetchPeplinkGraph(
						token,
						vesselId,
						"24",
						"",
						"",
						"Quality",
						"Cellular Signal Quality",
						dispatch,
						navigate,
					),
					fetchPeplinkGraph(
						token,
						vesselId,
						null,
						"",
						"",
						"Status",
						"Peplink Wans Status",
						dispatch,
						navigate,
					),
				]);
			} else {
				dispatch(setLoadingPeplink(false));
			}
		} else if (tabName === "fortigate") {
			dispatch(loadingCybersecurity(true));
			const data = await fetchCyberSecurity(token, vesselId, dispatch, navigate);
			dispatch(setCybersecurityData(data || []));
			await dispatch(setClearFortigate());
			await dispatch(setLoadingFortigate(true));

			if (hasFortigate) {
				await Promise.all([
					fetchFortigateGraph(
						token,
						vesselId,
						"3",
						"",
						"",
						"Ping_High_Latency",
						"Ping High Latency",
						dispatch,
						navigate,
					),

					fetchFortigateGraph(
						token,
						vesselId,
						"3",
						"",
						"",
						"STARLINK_Fortigate_Interface_Corporate",
						"STARLINK Fortigate Interface Corporate",
						dispatch,
						navigate,
					),

					fetchFortigateGraph(
						token,
						vesselId,
						"3",
						"",
						"",
						"STARLINK_Fortigate_Interface_Welfare",
						"STARLINK Fortigate Interface Welfare",
						dispatch,
						navigate,
					),

					fetchFortigateGraph(
						token,
						vesselId,
						"3",
						"",
						"",
						"STARLINK_Fortigate_Interface_WAN1",
						"STARLINK Fortigate Interface WAN1",
						dispatch,
						navigate,
					),

					// fetchFortigateGraph(
					//   token,
					//   vesselId,
					//   "3",
					//   "",
					//   "",
					//   "STARLINK_Fortigate_Interface_WAN2",
					//   "STARLINK Fortigate Interface WAN2",
					//   dispatch,
					//   navigate
					// ),
				]);
			} else {
				dispatch(setLoadingFortigate(false));
			}
		} else if (tabName === "cybersecurity") {
			dispatch(loadingCybersecurity(true));
			const data = await fetchCyberSecurity(token, vesselId, dispatch, navigate);
			dispatch(setCybersecurityData(data || []));
		} else if (tabName === "voucherServices") {
			dispatch(setVouchersData({ data: [], page: 1, perPage: 10, totalItems: 0 }));
		} else if (tabName === "yahsatServices") {
			dispatch(LoadingYahclick(true));

			await dispatch(setClearYahclick());

			const data = await fetchYahclickData(token, yahclickIds, dispatch, navigate);
			dispatch(setYahclickData(data || []));

			if (hasYahsatServices) {
				await Promise.all([
					// Yahclick
					...yahclickIds.map((id) =>
						Promise.all([
							fetchYahclickGraph(
								token,
								id,
								"3",
								"",
								"",
								"Ping_High_Latency",
								"Ping High Latency",
								dispatch,
								navigate,
							),
							fetchYahclickGraph(
								token,
								id,
								"3",
								"",
								"",
								"Fortigate_Interface_YahsatLink",
								"Fortigate Interface YahsatLink",
								dispatch,
								navigate,
							),
						]),
					),

					// Yahclick NG
					...yahclickIdsNG.map((id) =>
						Promise.all([
							fetchYahclickGraphNG(
								token,
								id,
								"3",
								"",
								"",
								"Ping_High_Latency",
								"Ping High Latency",
								dispatch,
								navigate,
							),
							fetchYahclickGraphNG(
								token,
								id,
								"3",
								"",
								"",
								"Fortigate_Interface_EUTLink",
								"Fortigate Interface EUTLink",
								dispatch,
								navigate,
							),
						]),
					),
				]);
			} else {
				dispatch(LoadingYahclick(false));
			}
		} else if (tabName === "voucherToken") {
			dispatch(setVoucherTokensData({ data: [], page: 1, perPage: 10, totalItems: 0 }));
		} else if (tabName === "inmarsatDp") {
			dispatch(setInmarsatData({ data: [], page: 1, perPage: 10, totalItems: 0 }));
		}
	};

	useEffect(() => {
		handleTabClick(defaultTab, false);
	}, [defaultTab]);

	const updatedTabs = tabs?.filter(
		(tab) =>
			!(tab.name === "cellular" && !hasSmartboxes) ||
			(tab.name === "starlink" && !hasStarlinks) ||
			(tab.name === "intelsat" && !intelsats.length) ||
			(tab.name === "cybersecurity" && !hasCyberSecurity) ||
			(tab.name === "fortigate" && !hasFortigate) ||
			(tab.name === "voucherServices" && !hasVouchers) ||
			(tab.name === "yahsatservices" && !hasYahsatServices) ||
			(tab.name === "voucherToken" && !hasVoucherToken) ||
			(tab.name === "inmarsatDp" && !hasInmarsat),
	);

	return (
		<div className="pt-6">
			<div className="border-gray-700 border-b px-2 py-1 text-center font-medium text-[10px] text-gray-400 sm:text-sm">
				<ul className="-mb-px flex flex-wrap">
					{updatedTabs?.map(
						(tab) =>
							tab.display != undefined &&
							tab.display === true && (
								<li key={tab.name} className="me-2">
									<a
										href="#"
										className={`inline-block rounded-t-lg border-transparent border-b-2 p-4 ${
											tab.disabled
												? "cursor-not-allowed text-gray-500" // Disabled state styling
												: selectedTab === tab.name
													? "active border-white text-white"
													: "hover:border-gray-300 hover:text-gray-300"
										}`}
										onClick={() => handleTabClick(tab.name, tab.disabled)}
									>
										{tab.label}
									</a>
								</li>
							),
					)}
				</ul>
			</div>
			{/* Render content of selected tab */}
			{tabs.map((tab) =>
				tab.name === selectedTab ? (
					<div key={tab.name} className="pt-4">
						{tab.content}
					</div>
				) : null,
			)}
		</div>
	);
};

export default Tabs;
